const token = new window.URLSearchParams(document.location.search).get('token');

export default token;
